import { render, staticRenderFns } from "./DailyReviewTable.vue?vue&type=template&id=6b1adf98"
import script from "./DailyReviewTable.vue?vue&type=script&lang=js"
export * from "./DailyReviewTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports